
import axios from '@/utils/request'

export default {
	// 2021-10-20
	forEntity(entityName, entityId) {
		return axios.get('/logserver/wedding-log?entityName=' + entityName + '&entityId=' + entityId)
	},
}

